import type { News } from '../interface/News';
import type { FC } from 'react';
import NextLink from 'next/link';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Flex, Text } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
export const NewsCard: FC<NewsCardProps> = ({
  title,
  category,
  hour,
  slug
}) => {
  return <Flex as={NextLink} passHref href={`${PATHS.news.index}/${slug}`} target="_self" flexDir="column" justifyContent="space-between" w="15.5rem" h="full" gap="s" p="l" borderWidth="1px" borderColor="border.secondary" bgColor="background.primary" borderRadius="xs" transition="background-color 0.2s ease-in-out" _hover={{
    bgColor: 'background.brandLight'
  }} data-sentry-element="Flex" data-sentry-component="NewsCard" data-sentry-source-file="NewsCard.tsx">
      <Flex justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="NewsCard.tsx">
        <Text size="m" px="s" py="3xs" borderRadius="3xs" bg="background.brandMid" color="content.inverse" data-sentry-element="Text" data-sentry-source-file="NewsCard.tsx">
          {hour.replace(':', 'h')}
        </Text>
        <ChevronRight color="content.brand" data-sentry-element="ChevronRight" data-sentry-source-file="NewsCard.tsx" />
      </Flex>
      <Text size="xl" noOfLines={3} dangerouslySetInnerHTML={{
      __html: title
    }} data-sentry-element="Text" data-sentry-source-file="NewsCard.tsx" />
      <Text size="l" color="action.active.brandLight" justifySelf="end" data-sentry-element="Text" data-sentry-source-file="NewsCard.tsx">
        {category}
      </Text>
    </Flex>;
};
export type NewsCardProps = Pick<News, 'id' | 'title' | 'category' | 'hour' | 'slug'>;